import axios from 'axios';

const getUserId = () => {
	const esignature = localStorage.getItem('esignature');
	return esignature ? JSON.parse(esignature).userId : null;
};

const getCustomerId = () => {
	const esignature = localStorage.getItem('esignature');
	return esignature ? JSON.parse(esignature).customerId : null;
};

const getToken = () => {
	const esignature = localStorage.getItem('esignature');
	return esignature ? `Bearer ${JSON.parse(esignature).token}` : null;
};

/**
 * Validates that the response is valid JSON and not HTML
 * @param {any} data - Response data to validate
 * @returns {boolean} - True if valid JSON response, false if HTML or invalid
 */
const isValidJsonResponse = (data) => {
	if (!data || typeof data === 'string') {
		// Check if response is HTML (starts with < or contains doctype)
		if (typeof data === 'string' && (data.trim().startsWith('<') || data.includes('<!doctype'))) {
			console.error('Received HTML response instead of JSON. Check API endpoint configuration.');
			return false;
		}
		return false;
	}
	return typeof data === 'object';
};

export const startCollaborationSession = async (formId, flowId) => {
	try {
		const userId = getUserId();
		const customerId = getCustomerId();
		const token = getToken();

		const wsHost = process.env.REACT_APP_HOST_WS;
		if (!wsHost) {
			console.error('REACT_APP_HOST_WS environment variable is not configured');
			throw new Error('WebSocket host not configured');
		}

		const response = await axios.post(
			`${wsHost}/api/v1/live/start-session`,
			{
				form_id: formId,
				flow_id: flowId,
				websocket_id: `ws-${Date.now()}`
			},
			{
				headers: {
					'x-client-id': customerId,
					'x-user-id': userId,
					'Authorization': token,
					'Content-Type': 'application/json'
				}
			}
		);

		// Validate response is proper JSON and not HTML
		if (!isValidJsonResponse(response.data)) {
			console.error('Invalid response from collaboration API:',
				typeof response.data === 'string' ? response.data.substring(0, 100) : response.data);
			throw new Error('Invalid response from collaboration service. Expected JSON but received HTML or invalid data.');
		}

		// Validate required fields in response
		if (!response.data.session_id || !response.data.websocket_url) {
			console.error('Missing required fields in collaboration response:', response.data);
			throw new Error('Invalid collaboration session response: missing session_id or websocket_url');
		}

		return response.data;
	} catch (error) {
		console.error('Failed to start collaboration session:', error);
		throw error;
	}
};

export const connectToWebSocket = (websocketUrl) => {
	const baseUrl = process.env.REACT_APP_HOST_WS;

	// Validate baseUrl exists
	if (!baseUrl) {
		console.error('REACT_APP_HOST_WS is not configured');
		throw new Error('WebSocket host not configured');
	}

	// Safely construct WebSocket URL
	let wsBaseUrl;
	try {
		wsBaseUrl = baseUrl.replace(/^http/, 'ws') + '/ws';
	} catch (error) {
		console.error('Failed to construct WebSocket URL from:', baseUrl);
		throw new Error('Invalid WebSocket host configuration');
	}

	const socket = new WebSocket(wsBaseUrl);

	socket.onopen = () => {
		console.log('WebSocket connection established');
	};

	socket.onerror = (error) => {
		console.error('WebSocket error:', error);
	};

	socket.onclose = (event) => {
		console.log('WebSocket connection closed:', event.code, event.reason);
	};

	return socket;
};
